import React from "react";
import classnames from "classnames";

import _str from "shared/util/_str";
import Actions from "okpay/actions/Actions";
import TextInput from "okpay/util/TextInput";

class Address extends React.Component {
	_onChange = (e) => {
		const { value } = e.target;
		Actions.updateField({ address: value });
	};

	render() {
		const classes = classnames({
			"okpay-item": true,
			"okpay-item-address": true,
		});

		return (
			<div className={classes}>
				<div className="okpay-item-element">
					<TextInput
						value={this.props.value}
						name="address"
						label={_str("We need your address too!")}
						onChange={this._onChange}
					/>
				</div>
			</div>
		);
	}
}

export default Address;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/fields/Address.jsx